module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('strong', [_vm._v("Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("11QPs"), _c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Psalms Scroll")]), _vm._v(" (Dead Sea Scrolls)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b. Ber.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Berakhot")]), _vm._v(" (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b. Sanh.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sanhedrin")]), _vm._v(" (Babylonian Talmud)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CEB")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Common English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CEV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contemporary English Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IBT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Interpreting Biblical Texts")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JPS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jewish Publication Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KJV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NRSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Lexicon of the Old Testament")]), _vm._v(". Ed. Ernst Jenni and Claus Westermann. Trans. Mark E. Biddle. 3 vols. Peabody, MA: Hendrickson, 1997.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df2b8d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Abbreviations.vue
// module id = 81
// module chunks = 0